/*LIBRARY*/

import React from "react"; // useState removed as it's no longer needed
// for styles
import { useSelector } from "react-redux";
import { Link, useLocation } from "react-router-dom";

/*STYLES*/

/*DATA*/
import dict from "../../Assets/data/dict.json";

// --- SUB-COMPONENT: Cleaned up ---
const FolderCard = ({ folder, docCount, language }) => {
  // Helper for sub-component translation
  const t = (key) => {
    if (!dict[key]) return key;
    return dict[key][language] || dict[key]["eng"];
  };

  return (
    <div className="folder-card">
      <div className="folder-cover-container">
        {folder.image_url ? (
          <img
            src={folder.image_url}
            alt={folder.name}
            className="folder-image"
          />
        ) : (
          <div className="folder-placeholder">
            <span>{folder.name}</span>
          </div>
        )}
      </div>
      <div className="folder-info">
        <h3 className="folder-title">{folder.name}</h3>
        <p className="folder-desc">
          {docCount} {t("Docs")}
        </p>
      </div>
    </div>
  );
};

const FOLDER_INTRO = ({
  folders,
  parent_link,
  get_blogs_by_folder,
  handle_blog_click,
  set_expanded_folders,
  generate_link_url,
}) => {
  const editor_reducer = useSelector((state) => state.editor_reducer) || {};

  const { parent_object } = editor_reducer;

  // 1. Initialize Hook
  const location = useLocation();

  // 2. Get language from URL
  const queryParams = new URLSearchParams(location.search);
  const language = queryParams.get("language") || "eng";

  // Helper for parent component translation
  const t = (key) => {
    if (!dict[key]) return key;
    return dict[key][language] || dict[key]["eng"];
  };

  return (
    <main>
      <section className="text_center margin_bottom_extra">
        <img
          src="https://s3.ap-southeast-3.amazonaws.com/mapid.jakarta.public/web_assets/maskot_read.png"
          alt="MAPID Mascot"
          className="mascot-image"
        />
        <div className="text_big margin_bottom">
          {parent_object?.name || "MAPID Platform User Documentation"}
        </div>
        <div className="text_bold sub_color">
          {t(
            "Find complete guides and technical references to maximize your spatial data analysis in the MAPID ecosystem",
          )}
        </div>
      </section>

      <section className="dashboard-grid">
        {folders.map((folder, idx) => {
          const folder_blogs = get_blogs_by_folder(folder.link);
          const first_doc = folder_blogs.length > 0 ? folder_blogs[0] : null;

          const hasLink = !!first_doc;
          const linkTarget =
            hasLink && generate_link_url
              ? generate_link_url(first_doc)
              : hasLink
                ? `/blog_list?parent_link=${parent_link}&blog_id=${first_doc._id}`
                : "#";

          const onCardClick = () => {
            if (hasLink) handle_blog_click(first_doc);
            set_expanded_folders((prev) => ({
              ...prev,
              [folder.link]: true,
            }));
          };

          const Wrapper = hasLink ? Link : "div";
          // Use CSS class for wrapper styles (text-decoration, etc)
          const wrapperProps = hasLink
            ? { to: linkTarget, className: "link-wrapper" }
            : { style: { cursor: "pointer" } }; // Small inline style kept for non-link pointer

          return (
            <Wrapper key={idx} {...wrapperProps} onClick={onCardClick}>
              <FolderCard
                folder={folder}
                docCount={folder_blogs.length}
                language={language}
              />
            </Wrapper>
          );
        })}

        {folders.length === 0 && (
          <div className="empty-state">
            {t("No folders found. Please create a new folder.")}
          </div>
        )}
      </section>
    </main>
  );
};

export default FOLDER_INTRO;
